import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const getEntity = (set) => async (id) => {
  try {
    set({ isLoading: true });

    const response = await api.get(`/compliances/${id}/`);
    const result = response.data;
    set({
      entityToView: result,
      entityId: id,
      isLoading: false,
    });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default getEntity;
